import { stats } from "@/mocks/site";

export default function StatsBar() {
  return (
    <section className="w-full px-4 md:px-8 -mt-8 md:-mt-10 relative z-10">
      <div className="rounded-lg border border-background-200 bg-background-50 paper-grain grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-background-200 overflow-hidden">
        {stats.map((item) => (
          <div key={item.label} className="px-5 py-6 md:px-7 md:py-7">
            <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{item.value}</p>
            <p className="mt-1.5 text-sm font-medium text-foreground-700">{item.label}</p>
            <p className="mt-1 text-xs text-foreground-500">{item.note}</p>
          </div>
        ))}
      </div>
    </section>
  );
}